module.exports = __webpack_public_path__ + "static/media/background-1920.277f9665.svg";